import { event } from 'jquery';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { EditTimeSlotSelectionComponent } from '../edit-time-slot-selection/edit-time-slot-selection.component';
import moment from 'moment';

@Component({
  selector: 'app-time-selection-component',
  templateUrl: './time-selection-component.component.html',
  styleUrls: ['./time-selection-component.component.scss'],
})
export class TimeSelectionComponentComponent implements OnInit {
  timeMode: any;

  ngOnInit(): void {
      
  }
  // @Input() selectedTime: string;
  showDateTime = false;
  selectedDate: string = "Select Date";
  selectedTime: string = "Select Time";
  timeSelection: string = 'now'; // Default to "Now"

  constructor(private modalController: ModalController, private popoverController: PopoverController) {}

  selectNow() {
    this.showDateTime = false;
    // Set current time logic
  }

  selectLater() {
    this.showDateTime = true;
  }

  onSegmentChanged(){
    console.log(this.timeSelection);
    if(this.timeSelection === 'later')
      this.selectedDate =moment().format("YYYY-MM-DD")

  }

  onDateChange(event: { detail: { value: string } }) {
    try {
      if (event.detail.value) {
        this.selectedDate = moment(event.detail.value).format("YYYY-MM-DD")
      }
    } catch (error) {
      console.error('Error formatting date:', error);
    }
  }

  timeModeChanged(event: CustomEvent) {
    this.timeMode = event.detail.value;
    if (this.timeMode === 'now') {
      this.selectedTime = 'Now';
    }
  }

 async timeClicked(ev :any){
    const popover = await this.popoverController.create({
      component: EditTimeSlotSelectionComponent,
      event: ev,
      translucent: true,
      componentProps: {
        selectedDate: this.selectedDate
      }
    });
  
    popover.onDidDismiss().then((result:any) => {
      if (result.data) {
        this.selectedTime =result.data;
      }
    });
  
    return await popover.present();
  }
  apply() {
    // Handle time application logic here
    this.dismissModal();
  }

  dismissModal() {
    this.popoverController.dismiss();

  }
  // timeChanged(event: CustomEvent) {
  //   this.selectedTime = event.detail.value;
  // }

  // apply() {
  //   this.modalController.dismiss(this.selectedTime);
  // }

  

}
